(function(){

  /********REMOVING UNWANTED ELEMENTS ON DIFFERENT SCREEN********/
  if(window.innerWidth >= 750){
    document.querySelectorAll(".should_hide_desktop")?.forEach(function(e){e.remove()});
  }else{
    document.querySelectorAll(".should_hide")?.forEach(function(e){e.remove()});
  }


  /**********ICON WITH TEXT SLIDER STYLING**********/

  const iconTextSlider = new Swiper(".icon_text--slider",{
    spaceBetween: 50,
    centeredSlides: true,
    speed: 5000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    loopedSlides: 4,
    slidesPerView:'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  })
  if(iconTextSlider.isLocked){
    const elements = iconTextSlider.$el;
    elements.forEach(function(e){e.classList.add("swiper-slides-disabled")});
  }


  /******SETTINGS HEIGHT AS VARIABLE OF HEADER AND ANNOUNCEMENT BAR ON HTML TAG******/

  function setHeight(){
    const announcementBar = document.querySelector(".shopify-section-announcement-bar");
    const header = document.querySelector(".shopify-section-header");
  
    let announcementBarHeight = 0;
    if(announcementBar){
      announcementBarHeight = announcementBar.clientHeight;
    }
    let headerHeight = 0;
    if(header){
      headerHeight = header.clientHeight;
    }
    document.body.style.setProperty('--header-original-height',announcementBarHeight + headerHeight + "px");
    document.body.style.setProperty('--announcement-original-height',announcementBarHeight + "px");
  }
  setHeight();
  window.addEventListener("resize",setHeight);

  /*******CUSTOM CHAT BUTTON STYLING*******/
  
    const custom_chat__icon = document.querySelectorAll("[custom_chat__icon]");
    if(custom_chat__icon.length > 0){
      custom_chat__icon.forEach(function(e){
        e.addEventListener("click",function(){
          document.querySelector("#dummy-chat-button-iframe")?.contentWindow.document.getElementById("dummy-chat-button").click();
          if(document.querySelector("inbox-online-store-chat#ShopifyChat")){
            document.querySelector("#ShopifyChat").shadowRoot.querySelector(".chat-app button.chat-toggle").click();
          }else{
            document.querySelector("#ShopifyChat")?.contentWindow.document.querySelector("button.chat-toggle").click();
          }
        })
      })
    }
  
    function shopifyChat(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  observer.disconnect();
                  resolve(document.querySelector(selector));
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

    function removeAttr(){
      const live_chat_trigger = document.querySelectorAll("[live_chat_trigger]");
      if(live_chat_trigger.length > 0){
        live_chat_trigger.forEach(function(e){
          e.removeAttribute("disabled");
        })
      }
    }
    shopifyChat('#dummy-chat-button-iframe').then((elm) => {
      elm.contentWindow.document.getElementById("dummy-chat-button").style.display = "none";
      const live_chat_trigger = document.querySelectorAll("[live_chat_trigger]");
      removeAttr();
    });
  
    shopifyChat('#ShopifyChat').then((elm) => {
      setTimeout(function(){
        let buttonStyling = "<style>button.chat-toggle{display: none !important;}</style>";
        if(document.querySelector("inbox-online-store-chat#ShopifyChat")){
          document.querySelector("#ShopifyChat").shadowRoot.querySelector(".chat-app").insertAdjacentHTML('beforebegin',buttonStyling);
        }else{
          document.querySelector("#ShopifyChat").contentWindow.document.body.insertAdjacentHTML('afterbegin',buttonStyling);
        }
        removeAttr();
      },2000)
    });

  /*********DRAWER CONTACT TRIGGERS*********/


    function openContactDrawer(trigger){
      const mobile_chat_popup = document.querySelector("[custom_chat_mobile]");
      if(mobile_chat_popup){
         if(trigger){
            mobile_chat_popup.classList.add("contact_popup_active");
            document.body.classList.add("contact_popup_active");
         }
         else{
            mobile_chat_popup.classList.remove("contact_popup_active");
            document.body.classList.remove("contact_popup_active");    
         }
      }
    }
    const drawer_contact_trigger = document.querySelectorAll("[drawer_contact_trigger]");
    if(drawer_contact_trigger.length > 0){
      drawer_contact_trigger.forEach(function(e){
        e.addEventListener("click",function(){
          openContactDrawer(true);
        })
      })
    }
    
    const custom_chat_mobile_close = document.querySelectorAll("[custom_chat_mobile_close]");
    if(custom_chat_mobile_close.length > 0){
      custom_chat_mobile_close.forEach(function(e){
        e.addEventListener("click",function(ele){
          openContactDrawer(false);
        })
      })
    }

    const custom_chat_mobile_back_trigger = document.querySelectorAll("[custom_chat_mobile_back_trigger]");
    if(custom_chat_mobile_back_trigger.length > 0){
      custom_chat_mobile_back_trigger.forEach(function(e){
        e.addEventListener("click",function(ele){
          ele.stopPropagation();
          ele.stopImmediatePropagation();
          openContactDrawer(false);
        })
      })
    }
    
    
  
})();
